import PropTypes from "prop-types";
import React from "react";
import { Icon, Input, Form as SemanticForm } from "semantic-ui-react";
import { validatePassword } from "../../utils/formValidation";
import { exists } from "../../utils/utils";
import Form from "../common/Form";

/**
 * Confirm password reset form
 */
class ConfirmPasswordResetForm extends React.Component {
  static propTypes = {
    /** Function to call when submitting form. */
    onSubmit: PropTypes.func
  };

  state = {
    isPasswordVisible: false
  };

  handlePasswordIconClick = () =>
    this.setState({ isPasswordVisible: !this.state.isPasswordVisible });

  _passwordsMatch = values => {
    if (values.password !== values.passwordConfirm) {
      return "Passwords must match";
    }
  };

  render() {
    return (
      <Form
        fields={[
          {
            name: "password",
            required: true,
            render: ({ input, meta }) => (
              <SemanticForm.Field
                iconPosition="left"
                icon={
                  <Icon
                    link
                    name={this.state.isPasswordVisible ? "eye" : "eye slash"}
                    onClick={this.handlePasswordIconClick}
                  />
                }
                error={
                  meta.touched &&
                  meta.error && {
                    content: meta.error,
                    pointing: "below"
                  }
                }
                control={Input}
                required={true}
                type={this.state.isPasswordVisible ? "text" : "password"}
                label={"New password"}
                placeholder="Enter new password"
                name={input.name}
                value={input.value}
                onBlur={input.onBlur}
                onFocus={input.onFocus}
                onChange={input.onChange}
              />
            )
          },
          {
            name: "confirm",
            required: true,
            render: ({ input, meta }) => (
              <SemanticForm.Field
                error={
                  !meta.active &&
                  meta.touched &&
                  meta.error && {
                    content: meta.error,
                    pointing: "below"
                  }
                }
                iconPosition="left"
                icon={
                  <Icon
                    link
                    name={this.state.isPasswordVisible ? "eye" : "eye slash"}
                    onClick={this.handlePasswordIconClick}
                  />
                }
                type={this.state.isPasswordVisible ? "text" : "password"}
                required={true}
                control={Input}
                label={"Confirm password"}
                placeholder="Re-enter new password"
                name={input.name}
                value={input.value}
                onBlur={input.onBlur}
                onFocus={input.onFocus}
                onChange={input.onChange}
              />
            )
          }
        ]}
        onSubmit={this.props.onSubmit}
        submitText="Confirm"
        validate={values => {
          const errors = {};
          if (!values.password) {
            errors.password = "This field is required";
          }
          const errorMessage = validatePassword(values.password);
          if (exists(errorMessage)) {
            errors.password = errorMessage;
          }
          if (!values.confirm) {
            errors.confirm = "This field is required";
          }
          if (values.password !== values.confirm) {
            errors.confirm = "Passwords do not match";
          }
          return errors;
        }}
      />
    );
  }
}

export default ConfirmPasswordResetForm;
